import { RestRequest, } from '@Utils/rest';
import { ISharedJourneyDraft, } from 'atlas-shared';

export * from './abstract/journey_draft.api.abstract';

export const publishJourneyDraft = (id: ISharedJourneyDraft['id'], payload: { remove: boolean }) => {
  return RestRequest.put<any, boolean | ISharedJourneyDraft>(`journey_draft/${id}/publish`, payload);
};
